import {findIndex, isArray} from 'lodash'

export const ListReducerActions = {
  HYDRATE: 'HYDRATE',
  UPDATE: 'UPDATE',
  CREATE: 'CREATE',
  REMOVE: 'REMOVE'
}

export const ListReducer = (state, action) => {
  const index = isArray(action.data) ? -1 : findIndex(state, i => i._id === action?.data?._id)

  switch (action.type) {
    case ListReducerActions.HYDRATE:
      return action.data
    case ListReducerActions.UPDATE:
      if (index !== -1) {
        const next = [...state]
        next.splice(index, 1, action.data)
        return next
      }
      break
    case ListReducerActions.CREATE:
      return [...state, action.data]
    case ListReducerActions.REMOVE:
      if (index !== -1) {
        const next = [...state]
        next.splice(index, 1)
        return next
      }
      break
    default:
      return state
  }
}
